(function () {
  if (!window.MB_BUNDLE_CONFIG) return;

  var config = window.MB_BUNDLE_CONFIG;
  var TOTAL_SELECTOR = '.gbbFooterDiscountedTotalValue';
  var ORIGINAL_CLASS = 'gbbFooterOriginalTotalValue';
  var ORIGINAL_COLOR = '#ff7992';
  var lastWrittenCents = null;
  var lastOriginalCents = null;

  // Flatten all free products from individual picks + collection products
  var allFreeProducts = (config.freeProducts || []).concat(
    (config.freeCollections || []).reduce(function (acc, col) { return acc.concat(col); }, [])
  );
  var FREE_PRODUCT_IDS = allFreeProducts.map(function (p) { return String(p.id); });

  // Seeded from Liquid (USD cents); overridden with active-currency DOM price when listing renders
  var priceCache = {};
  allFreeProducts.forEach(function (p) { priceCache[String(p.id)] = p.priceCents; });

  function getCartProductIds(ids) {
    return ids.filter(function (id) {
      return !!document.querySelector('.gbbSlotFooterProductContainer[productid="' + id + '"]');
    });
  }

  // Handles period-decimal ($1,628.00), comma-decimal (1.628,00), and no-decimal ($79)
  function parseCents(text) {
    var cleaned = text.replace(/[^0-9.,]/g, '');
    if (/\.\d{2}$/.test(cleaned)) {
      return Math.round(parseFloat(cleaned.replace(/,/g, '')) * 100);
    }
    if (/,\d{2}$/.test(cleaned)) {
      return Math.round(parseFloat(cleaned.replace(/\./g, '').replace(',', '.')) * 100);
    }
    return parseInt(cleaned.replace(/[.,]/g, ''), 10) * 100;
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // If Easy Bundles created gbbFooterOriginalTotalValue: recolor it.
  // If absent: create it with the pre-our-discount total, insert after the discounted element.
  function ensureOriginalDisplay(originalCents) {
    var valueContainer = document.querySelector('.gbbFooterTotalValueContainer');
    if (!valueContainer) return;
    var originalEl = valueContainer.querySelector('.' + ORIGINAL_CLASS);
    if (originalEl) {
      originalEl.style.color = ORIGINAL_COLOR;
    } else {
      var discountedEl = valueContainer.querySelector(TOTAL_SELECTOR);
      if (!discountedEl) return;
      var newEl = document.createElement('div');
      newEl.className = ORIGINAL_CLASS;
      newEl.dataset.mbCreated = 'true';
      newEl.style.color = ORIGINAL_COLOR;
      newEl.style.textDecoration = 'line-through';
      newEl.textContent = formatMoney(originalCents);
      discountedEl.insertAdjacentElement('afterend', newEl);
    }
  }

  setInterval(function () {
    // Read price from listing before overwriting with Free!! — captures active currency
    FREE_PRODUCT_IDS.forEach(function (id) {
      var priceEl = document.querySelector(
        'div.gbbProductItem[productid="' + id + '"] .gbbProductItemPrice'
      );
      if (priceEl && priceEl.innerText !== 'Free!!') {
        var parsed = parseCents(priceEl.innerText);
        if (parsed > 0) priceCache[id] = parsed;
        priceEl.innerText = 'Free!!';
      }
    });

    var totalEl = document.querySelector(TOTAL_SELECTOR);
    if (!totalEl) return;

    var inCartIds = getCartProductIds(FREE_PRODUCT_IDS);

    if (!inCartIds.length) {
      lastWrittenCents = null;
      lastOriginalCents = null;
      var ourEl = document.querySelector('.' + ORIGINAL_CLASS + '[data-mb-created]');
      if (ourEl) ourEl.remove();
      return;
    }

    var totalDiscount = inCartIds.reduce(function (sum, id) {
      return sum + (priceCache[id] || 0);
    }, 0);
    if (totalDiscount === 0) return;

    var currentCents = parseCents(totalEl.textContent);
    if (isNaN(currentCents) || currentCents <= 0) return;

    if (currentCents !== lastWrittenCents) {
      lastOriginalCents = currentCents;
      var adjustedCents = Math.max(0, currentCents - totalDiscount);
      lastWrittenCents = adjustedCents;
      totalEl.textContent = formatMoney(adjustedCents);
    }

    // Always check — React re-renders may have removed the element
    if (lastOriginalCents) ensureOriginalDisplay(lastOriginalCents);
  }, 250);
})();
